export function openLogin(loginpopUp){
  loginpopUp.classList.remove("hidden");
  let loginUrl = loginpopUp.dataset.url;
  loginpopUp.innerHTML = `
    <div class="absolute top-3 right-3 z-30">
      <button class="border-2 border-blue rounded-full flex justify-center items-center w-7 h-7 group" data-closepopup="true"><svg class="w-4 h-4 group-hover:rotate-270 duration-500"><use xlink:href="/spritemap.svg#sprite-close"></use></svg><span class="visually-hidden">Close</span></button>
    </div>
    <iframe id="nemid_iframe" class="not-loaded h-full w-full" name="nemid_iframe" src="${loginUrl}"></iframe>
  `

  let closePopup = loginpopUp.querySelector("[data-closepopup]");
  if (closePopup){
    closePopup.addEventListener('click', e =>{
      loginpopUp.classList.add("hidden");
      loginpopUp.innerHTML = "";
    })
  }
}